// ==================================================
// Developed by Ling F Wong (lingdotdev[at]gmail.com)
// for South China Morning Post Morning Studio
// Last updated: 17th Sep 2024
// ==================================================

// A jQuery $( document ).ready() block
$(document).ready(function () {
  // Registering a GSAP plugin
  gsap.registerPlugin(ScrollTrigger);

  // Fade-in animation with stagger effect for hero banner
  gsap.from(".hero__container > div > *", {
    scrollTrigger: {
      trigger: ".hero__container",
    },
    opacity: 0,
    duration: 2,
    ease: "power1.inOut",
    stagger: 0.3,
  });

  // Fade-in animation for rest of the page
  const fadeIn = (el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
      },
      opacity: 0,
      duration: 2,
      ease: "power1.inOut",
    });
  };

  fadeIn(".tabs__container");
  fadeIn("#episode-1");
  fadeIn("#episode-2");
  fadeIn("#episode-3");
  fadeIn("#episode-4");
  fadeIn(".subfooter__container");

  // Parallax scrolling effect for hero banner
  gsap.set(".hero__container", {
    backgroundPositionY: "0px",
  });

  gsap.to(".hero__container", {
    scrollTrigger: {
      trigger: ".hero__container",
      start: "top top",
      scrub: true,
    },
    backgroundPositionY: "200px",
    ease: "none",
  });

  // Animations for thumbnails

  // Episode 1
  gsap.set("#thumbnail-1", { top: "5%", left: "5%" });
  gsap.set("#thumbnail-bg-1", { top: "10%", left: "30%" });

  gsap.to("#thumbnail-1", {
    scrollTrigger: {
      trigger: "#episode-1",
      start: "top center",
      scrub: true,
    },
    top: "0%",
    left: "0%",
    ease: "none",
  });

  gsap.to("#thumbnail-bg-1", {
    scrollTrigger: {
      trigger: "#episode-1",
      start: "top center",
      scrub: true,
    },
    top: "15%",
    left: "35%",
    ease: "none",
  });

  // Episode 2
  gsap.set("#thumbnail-2", { top: "5%", right: "5%" });
  gsap.set("#thumbnail-bg-2", { top: "10%", right: "30%" });

  gsap.to("#thumbnail-2", {
    scrollTrigger: {
      trigger: "#episode-2",
      start: "top center",
      scrub: true,
    },
    top: "0%",
    right: "0%",
    ease: "none",
  });

  gsap.to("#thumbnail-bg-2", {
    scrollTrigger: {
      trigger: "#episode-2",
      start: "top center",
      scrub: true,
    },
    top: "15%",
    right: "35%",
    ease: "none",
  });

  // Episode 3
  gsap.set("#thumbnail-3", { top: "5%", left: "5%" });
  gsap.set("#thumbnail-bg-3", { top: "10%", left: "30%" });

  gsap.to("#thumbnail-3", {
    scrollTrigger: {
      trigger: "#episode-3",
      start: "top center",
      scrub: true,
    },
    top: "0%",
    left: "0%",
    ease: "none",
  });

  gsap.to("#thumbnail-bg-3", {
    scrollTrigger: {
      trigger: "#episode-3",
      start: "top center",
      scrub: true,
    },
    top: "15%",
    left: "35%",
    ease: "none",
  });

  // Episode 4
  gsap.set("#thumbnail-4", { top: "5%", right: "5%" });
  gsap.set("#thumbnail-bg-4", { top: "10%", right: "30%" });

  gsap.to("#thumbnail-4", {
    scrollTrigger: {
      trigger: "#episode-4",
      start: "top center",
      scrub: true,
    },
    top: "0%",
    right: "0%",
    ease: "none",
  });

  gsap.to("#thumbnail-bg-4", {
    scrollTrigger: {
      trigger: "#episode-4",
      start: "top center",
      scrub: true,
    },
    top: "15%",
    right: "35%",
    ease: "none",
  });
});
